import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { db, firebaseAuth } from '../utils/firebase-config';
import './HomeLf.css';
import logo from "../assets/version2/logo.png";
import detailmenu from "../assets/version2/detailmenu.png";
import peoples from "../assets/version2/peoples.png";
import Adicionar from "./Adicionar";
import { doc, setDoc } from "firebase/firestore";


function HomeOff(params) {
    

    const [mecanica, setMecanica] = useState(false);
    const [eletrica, setEletrica] = useState(false);
    const [eletronica, setEletronica] = useState(false);
    const [construcao, setConstrucao] = useState(false);
    const [construcaoCivil, setConstrucaoCivil] = useState(false);
    const [terceirizado, setTerceirizado] = useState(false);
    const [proprio, setProprio] = useState(false);
    const [conjunto, setConjunto] = useState(false);
    const [projetoNome, setProjetoNome] = useState('');
    const [comentariosIniciais, setComentariosIniciais] = useState('');
    const [descricao, setDescricao] = useState('');
    const [current, setCurrent] = useState('');
    const [aberto, setAberto] = useState('none')
    const [view, setView] = useState('');

    const [dataHome, setDataHome] = useState([]);
    const [notif, setNotif] = useState('none');
    const [notif2, setNotif2] = useState('none');

    const [have, setHave] = useState(false);

  var runtime = true;




    if(window.location.href.slice(window.location.href.length - 1, window.location.href.length) != '/') {
        document.querySelector('.oisumida').style.display = 'none';
    } else {
    
        document.querySelector('.oisumida').style.display = 'block';
        
    }





    const navigate = useNavigate();


    const [logado, setLogado] = useState(false);

    




















   













return (
<>






    <div style={{backgroundColor: 'rgb(250,250,250)', color: 'white',
        height: '80vh', width: '300px', position: 'absolute',
        zIndex: '900',
        borderRadius: '8px',
        top: '60px', right: '0px', display: notif2, padding: '10px 20px',
        flexFlow: 'column', overflowY: 'scroll', alignItems: 'start'
    }}
    onMouseLeave={()=> setNotif2('none')}
    >
        <h4 style={{color: 'black'}}>Notificações</h4>

      
        
        {
            dataHome.map((data, index)=> {
                return <>
                
                <div style={{color: 'rgb(63, 63, 63)', display: 'flex', fontSize: '14px', textAlign: 'start',
            fontFamily: 'Inter, serif', fontWeight: '100', paddingTop: '10px'
        }}>
        <i class="bi bi-info-circle" style={{fontSize: '30px', marginRight: '10px', color: 'rgb(117, 0, 117)'}}></i> 

       <a> {data.split('###master')[0].replaceAll(' ', '') == 'pendencia' ? 'Nova Pendência de nome' : 'Nova Mensagem'}  
        <a style={{fontWeight: 'bold'}}> {data.split('###master')[2]} </a> no projeto <a style={{fontWeight: 'bold'}}> {data.split('###master')[1]}</a></a> 
        </div>
                
                
                </>
            })
        }


   
    </div>











<div className="overhide" style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: `${view}px`, position: 'absolute',
display: aberto, justifyContent: 'center', alignItems: 'center', zIndex: '200', overflowY: 'hidden'
}}

>

<div style={{ width: '500px',borderRadius: '16px', position: 'absolute', top: '20vh', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div style={{cursor: 'pointer'}}
onClick={()=> setAberto('none')}
>    <i class="bi bi-x" style={{fontSize: '25px'}}
/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Título do Projeto</div>
<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira o título do projeto"
  onChange={(e) => setProjetoNome(e.target.value)  }
></input>
</div>


<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Descrição do Projeto</div>
<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira descrições do projeto"
  onChange={(e) => setDescricao(e.target.value)  }
></input>
</div>




<div style={{padding: '0px 30px', marginTop: '20px'}}>
<div style={{fontWeight: 'bold', marginBottom: '6px'}}>Informações do Projeto</div>
<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Insira informações do projeto"
  onChange={(e) => setComentariosIniciais(e.target.value)  }
></input>
</div>













</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>



 <div className="lqd-mobile-sec relative" style={{position: 'fixed', top: '0px', zIndex: '100', width: '100%'}}>
        <div className="lqd-mobile-sec-inner navbar-header flex items-stretch w-full">
            <div className="lqd-mobile-modules-container empty"></div>
            <button type="button" className="bg-transparent border-none navbar-toggle collapsed nav-trigger style-mobile flex relative items-center justify-end p-0" data-ld-toggle="true" data-bs-toggle="collapse" data-bs-target="#lqd-mobile-sec-nav"
            aria-expanded="false" data-toggle-options="{ &quot;changeClassnames&quot;:  {&quot;html&quot;:  &quot;mobile-nav-activated&quot;} }"><span className="sr-only">Menu</span> <span className="bars inline-block relative z-1"><span className="bars-inner flex flex-col w-full h-full"><span className="bar inline-block"></span> <span className="bar inline-block"></span> <span className="bar inline-block"></span></span>
                </span>
            </button> <a className="navbar-brand flex relative leading-1/4em"><span className="navbar-brand-inner">
                
                <img className="logo-default" src={logo} style={{maxHeight: '30px'}} alt="Lumera 3D" />
                
                </span></a></div>
        <div className="lqd-mobile-sec-nav w-full absolute z-10">
            <div className="mobile-navbar-collapse navbar-collapse collapse w-full" id="lqd-mobile-sec-nav" aria-expanded="false" role="navigation">
                <ul id="mobile-primary-nav" className="reset-ul lqd-mobile-main-nav main-nav lqd-submenu-toggle-hover">
                 
                    <li className="menu-item-has-children" style={{cursor: 'pointer'}} onClick={()=> navigate('/')}><a  className="leading-1/4em">Home <span className="submenu-expander absolute"></span> <span className="link-icon inline-flex hide-if-empty right-icon"><i className="lqd-icn-ess icon-ion-ios-arrow-down"></i></span></a></li>

                    
                        

                </ul>
            </div>
        </div>
    </div>


<nav>



 <div
  style={{
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #D9D9D9",
    height: 57
  }}
>
  <div style={{ display: "flex", padding: "10px 30px", alignItems: "center" }}>
    <img src={logo} style={{ width: 156, height: 29 }}
    onClick={()=> navigate('/')}
    />
  



    <div
      style={{
        fontFamily: "Inter, serif",
        fontSize: 13,
        color: "#424856",
        fontWeight: "bold",
        marginLeft: 30,
        cursor: 'pointer'
      }}
      onClick={()=> navigate('/')}
    >
      Home
    </div>

  



  </div>



    <div style={{backgroundColor: 'rgb(250,250,250)', color: 'white',
        height: '80vh', width: '300px', position: 'absolute',
        borderRadius: '8px',
        top: '60px', right: '50px', display: notif, padding: '10px 20px',
        flexFlow: 'column', overflowY: 'scroll', alignItems: 'start'
    }}
    onMouseLeave={()=> setNotif('none')}
    >
        <h4 style={{color: 'black'}}>Notificações</h4>

      
        
        {
            dataHome.map((data, index)=> {
                return <>
                
                <div style={{color: 'rgb(63, 63, 63)', display: 'flex', fontSize: '14px', textAlign: 'start',
            fontFamily: 'Inter, serif', fontWeight: '100', paddingTop: '10px'
        }}>
        <i class="bi bi-info-circle" style={{fontSize: '30px', marginRight: '10px', color: 'rgb(117, 0, 117)'}}></i> 

       <a> {data.split('###master')[0].replaceAll(' ', '') == 'pendencia' ? 'Nova Pendência de nome' : 'Nova Mensagem'}  
        <a style={{fontWeight: 'bold'}}> {data.split('###master')[2]} </a> no projeto <a style={{fontWeight: 'bold'}}> {data.split('###master')[1]}</a></a> 
        </div>
                
                
                </>
            })
        }


   
    </div>




</div>












































</nav>
</>
)
}

export default HomeOff;